<wlm-popup-wrapper [titleKey]="T_SCOPE + '.title'" [showCloseButton]="true" (popupClose)="cancel()">
  <!--{{ profileChartConfiguration.name }}-->
  <ng-container popup-content>
    <wlm-trend-chart
      *ngIf="profileChartConfiguration"
      [size]="calculatedSize$ | async"
      [chartSettings]="chartSettings"
      [disableInnerLoading]="false"
    ></wlm-trend-chart>
  </ng-container>
</wlm-popup-wrapper>
